(function (window, document) {
  'use strict';

  // CANVA-EDIT-LINK (2026-09-29): the one owner of the Canva share help on
  // every product page type that offers a Canva link (the older product page,
  // the designer and guided pages, App mode and Quick Build).
  //   1. The instruction line under the Canva link field (markup() below; the
  //      older product page renders the same words from Liquid, and a test
  //      keeps the two identical).
  //   2. "See how": a light help pop-up with three pictures of Canva's Share
  //      panel. A bottom sheet on phones, a small dialog on desktop. The
  //      pictures load only when the pop-up opens.
  //   3. The soft view-only check. A canva.com /design/.../view link is always
  //      view-only and /edit always editable (checked against the stored link
  //      shapes on 2026-09-29). Short canva.link links cannot be read, so they
  //      never show the hint. The hint never blocks: Add to cart always works.
  // The field shows only where the product's configuration offers the Canva
  // method, so this help follows configuration, never a product name.
  if (window.BgCanvaShareHelp) return;

  var COPY = {
    line: 'In Canva, click Share, set Access to Anyone with the link and Can edit, then copy the link.',
    lineTap: 'In Canva, tap Share, set Access to Anyone with the link and Can edit, then copy the link.',
    viewOnly: 'This link is view-only. In Canva, change Can view to Can edit and copy the link again.',
    // Quick Build's artwork summary tile (two short lines fit its fixed height).
    viewOnlyShort: 'Canva link is view-only. Set Can edit.',
    how: 'See how',
    title: 'Share your Canva design',
    close: 'Close',
    steps: [
      { image: 'bg-canva-share-step-1.webp', width: 560, height: 299, alt: 'Canva Share panel with the Access level menu open', caption: 'Click Share. Under Access level, choose Anyone with the link.' },
      { image: 'bg-canva-share-step-2.webp', width: 560, height: 292, alt: 'The Can view menu open with Can edit at the top', caption: 'Change Can view to Can edit.' },
      { image: 'bg-canva-share-step-3.webp', width: 560, height: 181, alt: 'Access set to Anyone with the link and Can edit, above the Copy link button', caption: 'Click Copy link, then paste the link here.' }
    ]
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // True only when the link is surely view-only: a canva.com design link whose
  // last path part is "view" (the keyed share link or the public view link).
  // A template link (mode=preview) lets our team make an editable copy, so it
  // never counts. The check is optional help: any failure (a limited URL
  // implementation, a missing searchParams) answers false and never interrupts
  // the field, the form or the purchase button.
  function readViewOnlyLink(value) {
    var raw = String(value == null ? '' : value).replace(/[​-‍﻿]/g, '').trim();
    if (!raw) return false;
    if (raw.charAt(0) === '<' && raw.charAt(raw.length - 1) === '>') raw = raw.slice(1, -1).trim();
    if (!/^[a-z][a-z0-9+.-]*:/i.test(raw)) raw = 'https://' + raw;
    var url = new URL(raw);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return false;
    if (String(url.hostname || '').toLowerCase().replace(/^www\./, '') !== 'canva.com') return false;
    var parts = String(url.pathname || '').split('/').filter(Boolean);
    if (parts.length < 3 || parts[0].toLowerCase() !== 'design') return false;
    if (parts[parts.length - 1].toLowerCase() !== 'view') return false;
    if (!url.searchParams || typeof url.searchParams.get !== 'function') return false;
    return String(url.searchParams.get('mode') || '').toLowerCase() !== 'preview';
  }

  function isViewOnlyLink(value) {
    try { return readViewOnlyLink(value) === true; } catch (_) { return false; }
  }

  function howButtonMarkup() {
    return '<button type="button" class="bg-canva-help__how" data-bg-canva-help-open aria-haspopup="dialog">' + escapeHtml(COPY.how) + '</button>';
  }

  // The instruction line and its hint share one grid cell: the hint takes the
  // line's place, so the page never moves when it appears (the hint is the
  // shorter text).
  // options.viewOnly draws the hint state in the first paint (a re-render
  // never flashes the line before the hint).
  function markup(options) {
    var settings = options && typeof options === 'object' ? options : {};
    var line = settings.verb === 'tap' ? COPY.lineTap : COPY.line;
    var viewOnly = settings.viewOnly === true;
    return '' +
      '<div class="bg-canva-help' + (viewOnly ? ' is-view-only' : '') + '" data-bg-canva-help data-bg-canva-help-view-only="' + (viewOnly ? 'true' : 'false') + '">' +
        '<p class="bg-canva-help__line" data-bg-canva-help-line>' + escapeHtml(line) + ' ' + howButtonMarkup() + '</p>' +
        '<p class="bg-canva-help__warn" data-bg-canva-help-warn role="status" aria-live="polite">' + (viewOnly ? escapeHtml(COPY.viewOnly) + ' ' + howButtonMarkup() : '') + '</p>' +
      '</div>';
  }

  function setViewOnly(box, viewOnly) {
    if (!box || !box.getAttribute) return false;
    var next = viewOnly === true;
    if ((box.getAttribute('data-bg-canva-help-view-only') === 'true') === next) return next;
    box.setAttribute('data-bg-canva-help-view-only', next ? 'true' : 'false');
    if (box.classList) box.classList.toggle('is-view-only', next);
    var warn = box.querySelector('[data-bg-canva-help-warn]');
    if (warn) warn.innerHTML = next ? escapeHtml(COPY.viewOnly) + ' ' + howButtonMarkup() : '';
    return next;
  }

  // A field that owns no runtime (the older product page) marks its input
  // data-bg-canva-help-source; the nearest data-bg-canva-help-scope holds the
  // help line.
  function syncSource(input) {
    if (!input || !input.closest) return;
    var scope = input.closest('[data-bg-canva-help-scope]') || input.parentElement;
    var box = scope ? scope.querySelector('[data-bg-canva-help]') : null;
    setViewOnly(box, isViewOnlyLink(input.value));
  }

  function syncAllSources(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-bg-canva-help-source]')).forEach(syncSource);
  }

  var MODAL_STYLES = '' +
    '.bg-canva-help-modal[hidden]{display:none !important;}' +
    '.bg-canva-help-modal,.bg-canva-help-modal *{box-sizing:border-box;}' +
    '.bg-canva-help-modal{position:fixed;inset:0;z-index:2147482870;display:grid;place-items:center;padding:1.5rem;}' +
    // display:block beats the theme's div:empty{display:none} (the backdrop is an empty div).
    '.bg-canva-help-modal > .bg-canva-help-modal__backdrop{display:block;position:absolute;inset:0;background:rgba(7,18,34,0.32);opacity:0;transition:opacity 180ms ease;touch-action:none;}' +
    '.bg-canva-help-modal__panel{position:relative;z-index:1;display:grid;gap:.875rem;width:min(28rem,100%);max-height:calc(100vh - 3rem);max-height:calc(100dvh - 3rem);overflow:auto;overscroll-behavior:contain;padding:1.25rem;border-radius:.75rem;background:#fff;color:#0f2941;box-shadow:0 1.5rem 3.5rem rgba(7,18,34,0.28);opacity:0;transform:translateY(.5rem);transition:opacity 180ms ease,transform 180ms ease;}' +
    '.bg-canva-help-modal.is-open .bg-canva-help-modal__backdrop{opacity:1;}' +
    '.bg-canva-help-modal.is-open .bg-canva-help-modal__panel{opacity:1;transform:none;}' +
    '.bg-canva-help-modal__panel:focus{outline:none;}' +
    '.bg-canva-help-modal__title{margin:0;color:#07120c;font-size:1.25rem;font-weight:800;line-height:1.2;letter-spacing:0;}' +
    '.bg-canva-help-modal__steps{display:grid;gap:1rem;margin:0;padding:0;list-style:none;counter-reset:bg-canva-step;}' +
    '.bg-canva-help-modal__step{display:grid;gap:.5rem;margin:0;counter-increment:bg-canva-step;}' +
    '.bg-canva-help-modal__caption{margin:0;color:#28455f;font-size:.9375rem;line-height:1.45;}' +
    '.bg-canva-help-modal__caption::before{content:counter(bg-canva-step) ". ";font-weight:800;}' +
    '.bg-canva-help-modal__image{display:block;width:100%;height:auto;border:1px solid rgba(15,41,65,0.14);border-radius:.5rem;background:#f4f7fb;}' +
    '.bg-canva-help-modal__close{display:inline-flex;align-items:center;justify-content:center;width:100%;min-height:2.875rem;padding:.6875rem .875rem;border:1px solid #b7c9df;border-radius:.5rem;background:#fff;color:#0f4c81;font:inherit;font-size:.9375rem;font-weight:800;cursor:pointer;}' +
    '.bg-canva-help-modal__close:hover,.bg-canva-help-modal__close:focus-visible{border-color:#0f4c81;background:#eef5ff;outline:none;}' +
    '@media screen and (max-width:749px){' +
      '.bg-canva-help-modal{place-items:end stretch;padding:0;}' +
      '.bg-canva-help-modal__panel{width:100%;max-height:88vh;max-height:88dvh;padding:1.125rem 1rem calc(1rem + env(safe-area-inset-bottom,0px));border-radius:.875rem .875rem 0 0;transform:translateY(1.5rem);transition-duration:220ms;}' +
    '}' +
    '@media (prefers-reduced-motion:reduce){.bg-canva-help-modal__backdrop,.bg-canva-help-modal__panel{transition:none;}}';

  function ensureStyles() {
    if (document.querySelector('style[data-bg-canva-help-style]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-bg-canva-help-style', '1');
    style.textContent = MODAL_STYLES;
    (document.head || document.documentElement).appendChild(style);
  }

  // The pictures sit beside this script on the theme's asset host.
  var scriptSrc = (document.currentScript && document.currentScript.src) || '';
  function assetUrl(name) {
    var src = scriptSrc;
    if (!src) {
      var tag = document.querySelector('script[src*="bg-canva-share-help.js"]');
      src = tag ? tag.src : '';
    }
    var match = String(src).match(/^(.*\/)bg-canva-share-help\.js(?:\?.*)?$/);
    return (match ? match[1] : '') + name;
  }

  function ensureModal() {
    var existing = document.querySelector('[data-bg-canva-help-modal]');
    if (existing) return existing;
    var modal = document.createElement('div');
    modal.className = 'bg-canva-help-modal';
    modal.hidden = true;
    modal.setAttribute('data-bg-canva-help-modal', '1');
    modal.innerHTML = '' +
      '<div class="bg-canva-help-modal__backdrop" data-bg-canva-help-close></div>' +
      '<section class="bg-canva-help-modal__panel" role="dialog" aria-modal="true" aria-labelledby="bg-canva-help-title" tabindex="-1">' +
        '<h2 class="bg-canva-help-modal__title" id="bg-canva-help-title">' + escapeHtml(COPY.title) + '</h2>' +
        '<ol class="bg-canva-help-modal__steps">' +
          COPY.steps.map(function (step) {
            return '<li class="bg-canva-help-modal__step">' +
              '<p class="bg-canva-help-modal__caption">' + escapeHtml(step.caption) + '</p>' +
              '<img class="bg-canva-help-modal__image" data-bg-canva-help-src="' + escapeHtml(step.image) + '" width="' + step.width + '" height="' + step.height + '" alt="' + escapeHtml(step.alt) + '" decoding="async">' +
            '</li>';
          }).join('') +
        '</ol>' +
        '<button type="button" class="bg-canva-help-modal__close" data-bg-canva-help-close>' + escapeHtml(COPY.close) + '</button>' +
      '</section>';
    document.body.appendChild(modal);
    return modal;
  }

  function getFocusable(modal) {
    return Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
  }

  var state = { opener: null, closeTimer: 0 };

  function focusQuietly(node) {
    if (!node || typeof node.focus !== 'function') return;
    try { node.focus({ preventScroll: true }); } catch (_) { node.focus(); }
  }

  function open(opener) {
    ensureStyles();
    var modal = ensureModal();
    window.clearTimeout(state.closeTimer);
    state.opener = opener || document.activeElement;
    Array.prototype.slice.call(modal.querySelectorAll('img[data-bg-canva-help-src]')).forEach(function (image) {
      if (!image.getAttribute('src')) image.setAttribute('src', assetUrl(image.getAttribute('data-bg-canva-help-src')));
    });
    var wasHidden = modal.hidden;
    modal.hidden = false;
    // The closed styles apply first (one style read), then the transition to open.
    if (wasHidden) void modal.offsetHeight;
    modal.classList.add('is-open');
    focusQuietly(modal.querySelector('[role="dialog"]'));
    return true;
  }

  function close() {
    var modal = document.querySelector('[data-bg-canva-help-modal]');
    if (!modal || modal.hidden) return false;
    modal.classList.remove('is-open');
    window.clearTimeout(state.closeTimer);
    state.closeTimer = window.setTimeout(function () {
      if (!modal.classList.contains('is-open')) modal.hidden = true;
    }, 200);
    var opener = state.opener;
    state.opener = null;
    if (opener && document.contains(opener)) focusQuietly(opener);
    return true;
  }

  function isOpen() {
    var modal = document.querySelector('[data-bg-canva-help-modal]');
    return !!(modal && !modal.hidden && modal.classList.contains('is-open'));
  }

  // Capture phase: the product page's own handlers never see or swallow a
  // help tap, and the help never changes a product choice.
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var opener = target.closest('[data-bg-canva-help-open]');
    if (opener) {
      event.preventDefault();
      open(opener);
      return;
    }
    if (target.closest('[data-bg-canva-help-close]') && target.closest('[data-bg-canva-help-modal]')) {
      event.preventDefault();
      close();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var modal = document.querySelector('[data-bg-canva-help-modal]');
    if (!modal || modal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    // The pop-up owns Tab while it is open (another page layer's focus trap
    // must not pull focus back under it).
    event.stopPropagation();
    var focusable = getFocusable(modal);
    if (!focusable.length) { event.preventDefault(); return; }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!modal.contains(document.activeElement)) { event.preventDefault(); focusQuietly(first); }
    else if (event.shiftKey && (document.activeElement === first || document.activeElement === modal.querySelector('[role="dialog"]'))) { event.preventDefault(); focusQuietly(last); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); focusQuietly(first); }
  }, true);

  function onSourceEvent(event) {
    var input = event.target;
    // Optional help: a failure here never stops the page's own listeners.
    try { if (input && input.matches && input.matches('[data-bg-canva-help-source]')) syncSource(input); } catch (_) {}
  }
  document.addEventListener('input', onSourceEvent, true);
  document.addEventListener('change', onSourceEvent, true);
  // A value the browser restored into the field (back button, form restore).
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncAllSources(document); });
  else syncAllSources(document);
  window.addEventListener('pageshow', function () { syncAllSources(document); });

  window.BgCanvaShareHelp = {
    copy: COPY,
    isViewOnlyLink: isViewOnlyLink,
    markup: markup,
    howButtonMarkup: howButtonMarkup,
    setViewOnly: setViewOnly,
    syncSource: syncSource,
    syncAllSources: syncAllSources,
    open: open,
    close: close,
    isOpen: isOpen
  };
})(window, document);
